import React from 'react';
import { ListingObjects, Modal } from 'hyperdb-utils';
import { HyperdbListing } from '../../../../hyperdb';

class Listing extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickAction = this.handleClickAction.bind(this);
    this.activateChannel = this.activateChannel.bind(this);
    this._action = null;
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.postDataSuccessful) {
      this.props.api.channel.setData({ postDataSuccessful: false });
      if (!nextProps.errorMessage) {
        let successMessage = '';
        if (this._action === 'activate') successMessage = `Channel ${this.props.selectedChannel.name} activated`;
        this.props.api.channel.setData({ successMessage });
        this.props.api.channel.fetchListing();
      }
    }
  }
  componentWillUnmount() {
    this.props.api.channel.setData({ selectedChannel: null, properties: null, showModalActivate: false });
  }
  render() {
    return (
      <div style={{height: '100%'}}>
        <ListingObjects
          { ...this.props }
          onClickAction={ this.handleClickAction }
        />
        {
          this.props.showModalActivate
            ? <Modal
                title={ `Activate channel: ${this.props.selectedChannel.name}` }
                onClose={ this.handleClickAction.bind(this, null) }
                onAccept={ this.activateChannel }
                loading={ this.props.loading }
              >
                <div>Are you sure you want to activate this channel ?</div>
              </Modal>
            : null
        }
      </div>
    );
  }

  handleClickAction(object, actionName) {
    if (!object) this.props.api.channel.setData({ selectedChannel: null, properties: null, showModalActivate: false, showModalSync: false });
    if (actionName === 'activate') {
      this.props.api.channel.setData({ selectedChannel: object, showModalActivate: true });
    }
  }
  activateChannel() {
    this._action = 'activate';
    this.props.api.channel.postData({
      url: `/${this.props.selectedChannel.id}/activate`,
      data: {},
    })
    .then(() => {
      this.handleClickAction(null);
    });
  }
}

Listing.propTypes = {
  api: React.PropTypes.object,
  loading: React.PropTypes.bool,
  showModalCreate: React.PropTypes.bool,
  actionForCreate: React.PropTypes.string,
  properties: React.PropTypes.array,
};

export default HyperdbListing({
  CustomComponent: Listing,
  collectionName: 'channels',
  namespace: 'channel',
  mountedUrl: '/channels',
  title: 'Channels',
  columns: [
    { attribute: 'name' },
    { attribute: 'type' },
    { attribute: 'protocol' },
    { attribute: 'enabled', value: (o) => o.enabled ? <i className="fas fa-check" /> : null },
  ],
  actions: [
    { name: 'activate', label: 'Activate', display: (o) => o.type === 'output' && !o.enabled },
  ],
});



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/channel/containers/Listing.jsx